exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_JI8s9jWp{width:64px;box-sizing:border-box;height:64px}.container_JI8s9jWp[centered=true]{margin-left:32px}.container_JI8s9jWp:after{content:\"\";display:block;position:absolute;left:0;top:0;right:0;bottom:0;box-sizing:border-box;border:1px solid hsla(0,0%,100%,.6)}", ""]);

// exports
exports.locals = {
	"container": "container_JI8s9jWp"
};